<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴일사전대체
      </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in codeList"
            :key="i"
            class="gntType-item"
          >
            <v-list-item-content @click="selectMenu(item)">
              <!-- 대체휴가 -->
              <v-list-item-title>
                <span class="time">{{ item.codeNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import {
  getHolReplaceAppCode,
  //getVaccinationCostValidChk,
} from '@/api/workStatus';
import routerNames from '@/const/routerConstants';
import { mapGetters } from 'vuex';
//import dayjs from 'dayjs';

export default {
  data: () => ({
    applLevelSheet: false, // 대상자명 화면플래그
    tgtName: '본인',
    selecttitle: '대상자명',
    realAmnt: '',
    applAmnt: '',
    codeList: [],
    famRshipCd: 'SE', // 기본값 본인
    mgrUserListProps: [],
    myslfSuptCntLimit: 0,
    myslfSuptAmntLimit: 0,
    spousSuptCntLimit: 0,
    spousSuptAmntLimit: 0,
    myslfPayCntSum: 0,
    myslfPayAmntSum: 0,
    spousPayCntSum: 0,
    spousPayAmntSum: 0,
  }),

  computed: {
    ...mapGetters(['GET_USER_DATA', 'GET_WORK_TYPE_CD']),
  },

  methods: {
    /* 신청서 선택 */
    async selectMenu(item) {
      this.$store.commit('SET_WORK_TYPE_CD', item.code);
      this.$store.commit('SET_WORK_TYPE_NM', item.codeNm);
      this.$store.commit('SET_NOTE1', item.note1);
      this.$router.push(routerNames.DateHolReplaceAppView);
    },
  },

  async mounted() {
    let params = {
      grCodeCd: 'T11011', // 근무종류코드
    };

    let response = await getHolReplaceAppCode(params);
    this.codeList = response.data.data;
  },

  components: {
    IconApprovalDoc,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
